import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8ae2b66a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ae2b66a')) {
      api.createRecord('8ae2b66a', component.options)
    } else {
      api.reload('8ae2b66a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8ae2b66a&", function () {
      api.rerender('8ae2b66a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/designation/index.vue"
export default component.exports